export default __webpack_public_path__ + "static/media/location_preview_s6_streamer_studio.449892fa.svg";